export const RESET_MODAL = 'RESET_MODAL';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const showModal = (modal) => dispatch => {
  dispatch({
    modal,
    type: SHOW_MODAL,
  });
}

export const hideModal = () => dispatch => {
  dispatch({
    type: RESET_MODAL,
  })
}

export const showSnackbar = (snackbar) => dispatch => {
  dispatch({
    snackbar,
    type: SHOW_SNACKBAR,
  })
}

export const hideSnackbar = () => dispatch => {
  dispatch({
    type: RESET_SNACKBAR,
  })
}
